export default __webpack_public_path__ + "static/media/home-digital-agency-img-12.d9d6df96.jpg";